import FacilitiesExaminations from "./FacilitiesExaminations";

/**
 * ExaminationCockpit
 * Handles all JS stuff for examination cockpit
 */
export default class ExaminationCockpit {


    /**
     * constructor
     *
     * @param selector
     */
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);
        let $plugin = this.$plugin;

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        // get count of examinations and show it in frontend
        _this.getExaminationsInfo();

        // check router event
        window.addEventListener("router", function (e) {

            // routing switch
            switch (e.detail.path.substring(0,4)) {
                case '#!/0':
                    _this.plannedExaminations();
                    break;
                case '#!/1':
                    _this.criticalExaminations();
                    break;
            }
        });

        // advanced filter toggle
        $plugin.on('click', '[data-tncp-elementtoggler-trigger]', function () {
            let value = $(this).data('tncpElementtogglerTrigger');
            $plugin.find('[data-tncp-viewmode-value]').val(value);
        });
    }


    /**
     * examination info for counting results
     */
    getExaminationsInfo() {
        let vm = this;
        const xhrUrl = this.$plugin.find('[data-tncp-examinationcockpit-count-xhr]').data('tncp-examinationcockpit-count-xhr');
        let $plannedElement = vm.$plugin.find('[data-tncp-examinationcockpit-count="planned"]');
        let $criticalElement = vm.$plugin.find('[data-tncp-examinationcockpit-count="critical"]');

        $plannedElement.hide();
        $criticalElement.hide();

        if (xhrUrl != undefined) {
            window.xhrRequest({
                url: xhrUrl,
                method: 'GET'
            }).then((response) => {
                if (response.data.planned) {
                    let result = `(${response.data.planned})`;
                    $plannedElement.html(result).fadeIn(300);
                }
                if (response.data.critical) {
                    let result = `(${response.data.critical})`;
                    $criticalElement.html(result).fadeIn(300);
                }
            }).catch((response) => {

            });
        }
    }


    /**
     * plannedExaminations
     */
    plannedExaminations() {
        if (this.plannedFilter instanceof FacilitiesExaminations === false) {
            this.plannedFilter = new FacilitiesExaminations('[data-tncp-plugin="ExaminationListPlanned"]');
        }
    }


    /**
     * criticalExaminations
     */
    criticalExaminations() {
        if (this.criticalFilter instanceof FacilitiesExaminations === false) {
            this.criticalFilter = new FacilitiesExaminations('[data-tncp-plugin="ExaminationListCritical"]');
        }
    }
}

